import { render, staticRenderFns } from "./PlatonMenu.vue?vue&type=template&id=012edd56&"
import script from "./PlatonMenu.vue?vue&type=script&lang=js&"
export * from "./PlatonMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports